import { newHttpService } from '../../services/new-http-service'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/configure-store'
import { SelectCompanyPrompt } from '../../cmps/general/select-company-prompt'
import ControlTable from '../../cmps/control/control-table'
import { getControlsByCompanyNameQuery } from '../../cmps/util-cmps/graphql-queries/controls-query'
import { Spinner } from '../../cmps/util-cmps/spinner'
import { useCachedFetch } from '../../hooks/use-cached-fetch'

export const ControlsPage: React.FC = () => {
    const companyName = useSelector((stateModule: RootState) => stateModule.companyName.value)

    const { data, isLoading, hasError } = useCachedFetch(
        companyName ? `controls:${companyName}` : null,
        async () => {
            const query = getControlsByCompanyNameQuery(companyName)
            const result = await newHttpService.graphql(companyName, query)
            return result.controlsByCompanyName as any[]
        }
    )

    if (!companyName) {
        return <div className="tablePageContainer">
            <SelectCompanyPrompt />
        </div>
    }

    return <div className="tablePageContainer">
        <p className="tableSubtitle">Manage controls for audit workflows.</p>
        {isLoading && <Spinner />}
        {!isLoading && !hasError && <ControlTable data={data || []} />}
        {!isLoading && hasError && <div className="error-hint">Failed to load data. Try refreshing the page or re-logging in.</div>}
    </div>
}
